__turbopack_context__.v({
  "avatar": "ConsultantSlimBanner-module-scss-module__AWx4ha__avatar",
  "banner": "ConsultantSlimBanner-module-scss-module__AWx4ha__banner",
  "banner--not-connected": "ConsultantSlimBanner-module-scss-module__AWx4ha__banner--not-connected",
  "body": "ConsultantSlimBanner-module-scss-module__AWx4ha__body",
  "consultant": "ConsultantSlimBanner-module-scss-module__AWx4ha__consultant",
  "ctas": "ConsultantSlimBanner-module-scss-module__AWx4ha__ctas",
  "description": "ConsultantSlimBanner-module-scss-module__AWx4ha__description",
  "headline": "ConsultantSlimBanner-module-scss-module__AWx4ha__headline",
  "main": "ConsultantSlimBanner-module-scss-module__AWx4ha__main",
  "primary-cta": "ConsultantSlimBanner-module-scss-module__AWx4ha__primary-cta",
  "secondary-cta": "ConsultantSlimBanner-module-scss-module__AWx4ha__secondary-cta",
  "text": "ConsultantSlimBanner-module-scss-module__AWx4ha__text",
});
